import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PrintMaster_PrintDynamicSQL,
  PrintMaster_DynamicSqlTemplateGeneration,
  PrintMaster_UpdateSqlTemplate
} from 'src/app/GlobalVariable';
import {
  PrintMasterPrintDynamicSQLRequestDTO,
  PrintMasterPrintDynamicSQLResponse,
  PrintMasterPrintDynamicSQLResponseList,
  DynamicSqlTemplateGenerationRequestDTO,
  DynamicSqlTemplateGenerationResponseDTO,
  UpdateSqlTemplateRequestDTO,
  UpdateSqlTemplateResponseDTO
} from './PrintMaster.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MasterPrintMasterServices {
  http = inject(HttpClient);

  PrintMaster_PrintDynamicSQL(data: PrintMasterPrintDynamicSQLRequestDTO): Observable<PrintMasterPrintDynamicSQLResponseList> {
    return this.http.post<PrintMasterPrintDynamicSQLResponseList>(PrintMaster_PrintDynamicSQL, data);
  }

  PrintMaster_DynamicSqlTemplateGeneration(
    data: DynamicSqlTemplateGenerationRequestDTO
  ): Observable<DynamicSqlTemplateGenerationResponseDTO> {
    return this.http.post<DynamicSqlTemplateGenerationResponseDTO>(
      PrintMaster_DynamicSqlTemplateGeneration,
      data
    );
  }

  PrintMaster_UpdateSqlTemplate(
    data: UpdateSqlTemplateRequestDTO
  ): Observable<UpdateSqlTemplateResponseDTO> {
    return this.http.post<UpdateSqlTemplateResponseDTO>(
      PrintMaster_UpdateSqlTemplate,
      data
    );
  }
}
